module.exports = __webpack_public_path__ + "img/site-0-1.8db24fb0.svg";